import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { CenterCourtSection } from '@/components/landing/center-court-section'
import { FaqSection } from '@/components/landing/faq-section'
import { HeroSection } from '@/components/landing/hero-section'
import { NumbersSection } from '@/components/landing/numbers-section'
import { PlaySection } from '@/components/landing/play-section'
import { PointSection } from '@/components/landing/point-section'
import { TicketsSection } from '@/components/landing/tickets-section'
import { WeekSection } from '@/components/landing/week-section'
import { siteConfig } from '@/constants/site'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo ogImage={siteConfig.ogImage} />

            <HeroSection />
            <NumbersSection />
            <PointSection />
            <WeekSection />
            <CenterCourtSection />
            <PlaySection />
            <TicketsSection />
            <FaqSection />
        </Layout>
    )
}

export default Home
